module.exports = __webpack_public_path__ + "img/4.c9e5ab9a.png";